import { Component, EventEmitter, Input, Output } from '@angular/core';
import { appSettings } from 'app/appSettings';
import { ClientUser, ClientUsers } from '../../../../core/store/admin/users/users.interface';
import { UserListComponent } from '../../abstract-user/user-list/user-list.component';
import { util } from '../../../../core/util/util';
import { fadeInAnimation } from '../../../../animations';
import { UserRestService } from '../../../../core/services/rest/admin/user.rest.service';
import { ScrollService } from '../../../../core/services/scroll.service';

@Component({
  selector: 'admin-client-user-list',
  templateUrl: './client-user-list.component.html',
  styleUrls: ['./client-user-list.component.scss'],
  animations: [fadeInAnimation],
})
export class ClientUserListComponent extends UserListComponent {
  dateFormat: string = appSettings.DATE_FORMAT_ANGULAR;

  @Input() isLoading: boolean;
  @Input() users: ClientUser[];
  @Input() isDownloading = false;
  @Output() openUser: EventEmitter<ClientUser> = new EventEmitter();
  @Output() sortChange: EventEmitter<{ sortField: string; sortAscending: boolean }> = new EventEmitter();
  @Output() itemsPerPageChange = new EventEmitter<number>();
  @Output() downloadList = new EventEmitter<string>();
  userLoading = {};
  syncInProgress = false;

  constructor(private userRestService: UserRestService, scrollService: ScrollService) {
    super(scrollService);
  }

  sort(field: string) {
    util.sortHelper({ sortChange: this.sortChange, filter: this }, field);
  }

  sortBnd = this.sort.bind(this);

  assign(user: ClientUser) {
    this.userLoading[user.id] = true;
    this.userRestService.assignToLoop(user.id, 'EpsUser').subscribe(
      res => {
        this.userLoading[user.id] = false;
        this.pageChange.emit(this.pageNr);
      },
      () => {
        this.userLoading[user.id] = false;
        this.pageChange.emit(this.pageNr);
      }
    );
  }

  syncUsers() {
    this.syncInProgress = true;
    this.userRestService.syncWithAD().subscribe(
      res => {
        this.syncInProgress = false;
        this.pageChange.emit(this.pageNr);
      },
      () => {
        // error
        this.pageChange.emit(this.pageNr);
        this.syncInProgress = false;
      }
    );
  }
}
